module.exports = __webpack_public_path__ + "static/media/room-11.f08fee37.jpeg";